// extracted by mini-css-extract-plugin
module.exports = {"section":"AddEmploymentTypeDialog_section__2I2XI","btn":"AddEmploymentTypeDialog_btn__H1K6J"};